export class SetDoneShowIntroVideoModel {
  constructor() {
    this.UserId = 0;
  }

  public UserId: number;
  public CompanyId: number;
}
